export const LANGUAGE = {
  en: { value: "en", id: 3205 },
  vn: { value: "vn", id: 27956 },
  kor: { value: "kor", id: 18121 },
  jap: { value: "jap", id: 2811 },
};

export const getMultiLanguageProp = (prop, language) =>
  prop[language] || prop.vn;
